import { Breadcrumb } from "antd";
import React from "react";

export const BreadCrumbs = (props) => {
  return (
    <div>
      <Breadcrumb className="page-header" {...props.breadProps}>
        {props.headers.map((header) => (
          <Breadcrumb.Item key={header} onClick={props.onParentActionClick}>
            {header}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};
